import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';
// Local component
import { LoginComponent } from './login.component';
//Service file
import { UserQueryService } from '../../gql-query-mutation/index';

const routes = [
    {
        path: 'login',
        component: LoginComponent,
    }
];

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        UserQueryService
    ],
})

export class LoginModule {

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/login/login.module.ts